<template>
    <div>
        <app-sub-title text="Filtros" />
        <div class="d-flex align-items-end">
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.vigilant"
                    label="Nombre vigilante"
                />
            </div>
            <div class="px-2">
                <app-date-time-picker 
                    id="startTime"
                    label="Inicio de turno"
                    v-model="filters.startTime" 
                    :with-time="false">
                </app-date-time-picker>
            </div>
            <div class="px-2">
                <app-date-time-picker 
                    id="endTime"
                    label="Fin de turno"
                    v-model="filters.endTime" 
                    :with-time="false">
                </app-date-time-picker>
            </div>
            
            <div class="px-2">
                <b-button variant="primary" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
            </div>
            <div class="px-2">
                <b-button variant="secondary" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
            </div>
        </div>
    </div>
</template>
<script>
import DateTimePicker from '../../../UI/Controls/DateTimePicker/DateTimePicker.vue';
export default {
    components: {
        appDateTimePicker: DateTimePicker
    },
    data(){
        return {
            filters: {
                vigilant: '',
                startTime: '',
                endTime: ''
            }
        }
    },
    methods: {
        clearFilters(){
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>
